import { render, staticRenderFns } from "./OldReservation.vue?vue&type=template&id=7ecd63d6&scoped=true&"
import script from "./OldReservation.vue?vue&type=script&lang=js&"
export * from "./OldReservation.vue?vue&type=script&lang=js&"
import style0 from "./OldReservation.vue?vue&type=style&index=0&id=7ecd63d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecd63d6",
  null
  
)

export default component.exports